var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/js/cart-free-gift-aiod.js ***!
  \***************************************/
document.addEventListener("DOMContentLoaded", function () {
  var htmlElement = document.querySelector("html");
  var siteLanguage = htmlElement.getAttribute("lang");
  var handleDomChanges = function handleDomChanges(mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === "childList") {
        var addedNodes = mutation.addedNodes;
        addedNodes.forEach(function (addedNode) {
          if (addedNode.classList && addedNode.classList.contains("cs_show")) {
            // Update immediately on page load
            updateMoneyElements();

            // Redo the check after a 3-second delay
            setTimeout(updateMoneyElements, 3000);
          }
        });
      }
    });
  };

  // Function to update money elements
  var updateMoneyElements = function updateMoneyElements() {
    var csAppsPriceList = document.querySelectorAll(".csapps-price");
    csAppsPriceList.forEach(function (csAppsPrice) {
      var moneyElements = csAppsPrice.querySelectorAll(".money");
      moneyElements.forEach(function (moneyElement) {
        var moneyValue = moneyElement.innerHTML;
        moneyValue = moneyValue.replace(/[^\d.]/g, ""); // Remove non-numeric characters

        if (/^\d/.test(moneyValue)) {
          var formattedValue = parseFloat(moneyValue).toFixed(2);
          moneyElement.innerHTML = siteLanguage === "en" ? "$" + formattedValue : formattedValue + "$";
        }
      });
    });
  };
  var observer = new MutationObserver(handleDomChanges);
  var observerConfig = {
    childList: true,
    subtree: true
  };
  observer.observe(document.body, observerConfig);

  // Update money elements immediately on page load
  window.onload = function () {
    updateMoneyElements();
  };
});
